<template>
  <div class="spotlight-container px-0">
    <div class="spotlight-wrapper">
      <MobialisHorizontalRuleHeader class="mb-4 spotlight-inner-wrapper" v-if="isLegacyFlow">
        <slot name="header">
          <img :src="require('@/assets/sxm-logo-blue.svg')" width="100" height="21" />
        </slot>
      </MobialisHorizontalRuleHeader>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpotlightWrapper',
  computed: {
    isLegacyFlow() {
      return !!this.$route.meta.hasSxmHeader;
    },
  },
};
</script>

<style scoped lang="scss"></style>
